import { Button, Label, Layout, LayoutHeader, Panel, SaveButton } from "@mcleod/components";

export abstract class AutogenLayoutMenuEditor extends Layout {
    buttonAddItem: Button;
    buttonAddSubMenu: Button;
    buttonDeleteItem: Button;
    buttonEditItem: Button;
    buttonExecutedChanges: Button;
    buttonInclude: Button;
    buttonMove: Button;
    buttonMoveDown: Button;
    buttonMoveUp: Button;
    buttonSave: SaveButton;
    buttonScript: Button;
    buttonViewChanges: Button;
    labelSelection: Label;
    layoutheader: LayoutHeader;
    panelActions: Panel;
    panelRight: Panel;
    panelTree: Panel;
}
